/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const headerMiniCartMenuSX: SxProps = {
	width: '300px',
};

export const headerMiniCartMenuCustomSX = (theme: Theme): SxProps => ({
	alignSelf: 'center',
	width: '385px',
	[theme.breakpoints.down('lg')]: {
		width: '100%',
	},
	'& .table-container': {
		maxHeight: '40vh',
		overflow: 'auto',
	},
});
